const queryKeys = {
  dataIntegrations: ["data-integrations"] as const,
  jiraIntegration: ["integrations", "jira"] as const,
  slackIntegration: ["integrations", "slack"] as const,
  userGroupConfigs: ["user-group-configs"] as const,
};

export default queryKeys;
